/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Config from 'config'
import Graphql from '@/services/Graphql'
import HttpProvider from '@/services/HttpProvider'
import storePickupAvailable from 'theme/services/graphQlquery/storesPickupAvailable'
import { writeOperationLog } from 'theme/helpers'

export default {
  getAllBoutique (ctx) {
    let url = Config.API.storeLocator.allBoutiques
    let config = {
      headers: {
        'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`,
        'Store': ctx.rootState.ui.storeViewCode
      }
    }
    return HttpProvider.get(url, config)
      .then(resp => {
        ctx.commit('setBoutiques', resp.data)
        return resp.data
      })
  },
  getBoutique (ctx, code) {
    let url = Config.API.storeLocator.singleBoutique
    url = url.replace('{{code}}', code)
    return HttpProvider.get(url)
      .then(resp => {
        ctx.commit('setBoutique', resp.data[0])
        return resp.data[0]
      })
  },
  getBoutiqueByLocations (ctx, { coordinates }) {
    let url = Config.API.storeLocator.boutiquesByLocation
    return HttpProvider.post(url, {
      params: coordinates
    })
      .then(resp => {
        return resp.data
      })
  },
  getProductOnStore (ctx, params) {
    let url = Config.API.storeLocator.productOnStore
    return HttpProvider.get(url,
      {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`,
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: params
      })
      .then(resp => {
        return resp
      })
  },
  pickupStores (ctx, { area, filters, sort, pageSize = 1, currentPage = 20, productsInfo = [] }) {
    return Graphql.genericCallCash({
      storeViewCode: ctx.rootState.ui.storeViewCode,
      useInlineQuery: storePickupAvailable,
      variables: {
        area,
        filters,
        sort,
        pageSize,
        currentPage,
        productsInfo
      }
    })
      .then(res => {
        return res
      })
  },
  updateStore (ctx, { code, attributes, useKeyForCall = '' }) {
    // useKeyForCall is used to match config.api.storeLocator key
    // to get right query to call
    let query = Config.API.storeLocator.updateStore
    if (useKeyForCall && Config.API.storeLocator[useKeyForCall]) {
      query = Config.API.storeLocator[useKeyForCall]
    }
    query = query.replace('{{code}}', code)
    return HttpProvider.post(query,
      { ...attributes },
      {
        headers: {
          'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`,
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then((resp) => {
        if (resp && resp.data) {
          writeOperationLog('edit-boutique', ctx.rootGetters['userAdmin/getCurrentAgentID'])
          return ctx.dispatch('getBoutique', resp.data.code)
        }
      })
      .catch(error => {
        throw error
      })
  },
  getPickupIdFromLocation (ctx, locationCode) {
    let variables = {
      input: {
        location_code: locationCode
      }
    }
    return Graphql.genericCallCash({
      token: ctx.rootState.user.token, // token
      storeViewCode: ctx.rootState.ui.storeViewCode, // storeViewCode
      graphSchemaType: 'getPickupLocationIdFromCode',
      variables
    })
      .then((res) => {
        if (res.data) {
          return res.data.getPickupIdFromLocation
        }
      })
  },
  getStorePickup (ctx) {
    // get all store by clickandcollect
    const query = Config.API.storeLocator.allClickAndCollect
    return HttpProvider.get(query)
      .then((res) => {
        if (res.data) {
          return res.data
        }
      })
  }
}
